import React from "react";
import moment from "moment";
import { compose } from "redux";
import { Grid, Tooltip } from "@material-ui/core";
import CheckBox from "@material-ui/icons/CheckBox";
import { withStyles } from "@material-ui/core/styles";
import CheckBoxOutlineBlank from "@material-ui/icons/CheckBoxOutlineBlank";

import Link from "app/components/Link";
import config from "infrastructure/config";
import { formatDate } from "utils/format.util";
import { EMPTY_LIST, Format } from "app/app.constants";

const EmployeeProjectsContainer = ({
  classes,
  employeeProjects = EMPTY_LIST,
  projects = EMPTY_LIST,
  onUnassignProject,
  onAssignProject,
}) => {
  return (
    <>
      <Grid container className={classes.root}>
        <Grid item className={classes.title}>
          {"Assigned Projects"}
        </Grid>

        {projects.size === 0 && (
          <Grid item container>
            {"N/A"}
          </Grid>
        )}
        {projects &&
          projects.map(project => {
            const isProjectMember = employeeProjects.find(
              x =>
                x.get("projectId")?.toString() ===
                project.get("projectId")?.toString(),
            );
            return (
              <Grid
                item
                container
                key={project.get("projectId")}
                className={classes.row}
              >
                <Grid xs={1} item>
                  {isProjectMember ? (
                    <CheckBox
                      onClick={() => {
                        return onUnassignProject(project.get("projectId"));
                      }}
                    />
                  ) : (
                    <CheckBoxOutlineBlank
                      onClick={() => onAssignProject(project.get("projectId"))}
                    />
                  )}
                </Grid>
                <Grid xs={4} item>
                  {project.get("displayName")}
                </Grid>
                <Grid item className={classes.m3num}>
                  {project.get("m3ProjectNumber")}
                </Grid>
                <Grid item xs={3}>
                  <Grid item>
                    {project.get("startTime")
                      ? formatDate(
                          moment(project.get("startTime")),
                          Format.date,
                        )
                      : ""}{" "}
                    -{" "}
                    {project.get("endTime")
                      ? formatDate(moment(project.get("endTime")), Format.date)
                      : ""}
                  </Grid>
                </Grid>
                <Grid xs item container justifyContent="flex-end">
                  <Tooltip title={"Go to project"}>
                    <Link
                      classes={{
                        root: classes.projectLink,
                        icon: classes.linkIcon,
                      }}
                      external
                      target="_blank"
                      // TODOA open DWI
                      href={`${config.diClientUrl}/projects/${project.get(
                        "dwiProjectId",
                      )}`}
                    ></Link>
                  </Tooltip>
                </Grid>
              </Grid>
            );
          })}
      </Grid>
    </>
  );
};

const styles = theme => ({
  title: {
    color: theme.palette.text.secondary,
  },
  root: {
    top: 0,
    zIndex: 2,
    width: "100%",
    display: "flex",
    position: "sticky",
    alignItems: "center",
    color: theme.palette.common.black,
    fontSize: "1rem",
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(1.5),
  },
  row: {
    marginTop: theme.spacing(0.5),
    padding: theme.spacing(1.2),
    alignItems: "center",
    justifyContent: "center",
    background: theme.palette.grey[300],
  },
  chipRoot: {
    height: "1.5rem",
    background: theme.altus.background.headerChip,
    color: theme.palette.primary.contrastText,
    fontWeight: theme.typography.fontWeightBold,
  },
  projectLink: {
    "&:hover": {
      cursor: "pointer",
      textDecoration: "underline",
    },
  },
  linkIcon: {
    fontSize: "1.75rem",
  },
  m3num: {
    marginRight: "15px",
  },
});
export default compose(withStyles(styles))(EmployeeProjectsContainer);
